export default __webpack_public_path__ + "static/media/wall.e86a78df.svg";